import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
// 引入video.js

import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Videojs
Vue.use(ElementUI);
/* 引入字体 */
import '../src/style/index.css'
import { Service } from './api/config'//axios配置
Vue.prototype.$axios = Service
import '@vant/touch-emulator';//vant 在pc端使用需要引入
import { Picker } from 'vant';
Vue.use(Picker);
import less from 'less'
Vue.use(less)
import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js';
Vue.use(VueFullPage);
import animated from 'animate.css';
Vue.use(animated)
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js